var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 8C16 3.5805 12.4165 0 8 0C3.5805 0 0 3.5805 0 8C0 11.992 2.9245 15.302 6.75 15.9015V10.313H4.7185V8.0005H6.75V6.237C6.75 4.2325 7.9425 3.1255 9.7705 3.1255C10.646 3.1255 11.5625 3.2815 11.5625 3.2815V5.25H10.552C9.56 5.25 9.25 5.8675 9.25 6.5V8H11.4685L11.112 10.3125H9.25V15.901C13.0725 15.3015 16 11.9915 16 7.9995V8Z","fill":"#F0EEEE"}));
}

Facebook.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
